var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lines.length)?_c('p',{staticClass:"text-multiline",class:_vm.getBemModifiers()},[_vm._l((_vm.lines),function(line){return [_vm._v("\n        "+_vm._s(line)+" "),_c('br',{staticClass:"break-line"})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }